import React, { useEffect, useRef } from "react";
import "./Capabilities.css";
import { 
  FaCubes, 
  FaDraftingCompass, 
  FaLayerGroup, 
  FaTools, 
  FaCogs, 
  FaIndustry 
} from "react-icons/fa";

function OurCapabilities() {
  const sectionRef = useRef(null);

  const capabilities = [
    {
      id: 1,
      title: "Metal 3D Printing (DMLS)",
      icon: <FaIndustry />,
      desc: "Precision-grade stainless steel, aluminum & titanium printing for functional, industrial components.",
    },
    {
      id: 2,
      title: "Plastic 3D Printing",
      icon: <FaCubes />,
      desc: "Rapid SLS, SLA, FDM & MJF 3D printing solutions using ABS, PLA, Nylon, PETG, and high-performance engineering-grade polymers.",
    },
    {
      id: 3,
      title: "Mold Making & Tooling",
      icon: <FaLayerGroup />,
      desc: "Custom molds for injection molding with high accuracy, long life & optimized parting design.",
    },
    {
      id: 4,
      title: "Injection Molding",
      icon: <FaTools />,
      desc: "We offer low and high-volume plastic part production with consistent quality, tight dimensional tolerances, and fast turnaround times.",
    },
    {
      id: 5,
      title: "Rapid Prototyping",
      icon: <FaCogs />,
      desc: "Fast manufacturing of prototypes for testing, validation & pre-production evaluation.",
    },
    {
      id: 6,
      title: "Design & CAD Engineering",
      icon: <FaDraftingCompass />,
      desc: "Complete CAD modeling, drawing support & design optimization for manufacturing readiness.",
    },
  ];

  // Reveal animation triggers
  useEffect(() => {
    const el = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          el.classList.add("cap_reveal");
        } else {
          el.classList.remove("cap_reveal");
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="cap_section" ref={sectionRef}>
      <div id="cap_container">

        <h2 id="cap_heading" className="cap_item cap_d1">
          Our <span>Capabilities</span>
        </h2>

        <p id="cap_subtext" className="cap_item cap_d2">
          Advanced manufacturing services designed for precision, speed, and production-ready performance.
        </p>

        <div id="cap_grid">
          {capabilities.map((item, index) => (
            <div 
              key={item.id}
              id={`cap_card_${item.id}`}
              className={`cap_card_id cap_item cap_d${index + 3}`}
            >
              <div id="cap_icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default OurCapabilities;
